import Toasted from "vue-toasted";
import Vue from "vue";

Vue.use(Toasted, {
  theme: "bubble",
  duration: 3000,
});
